// https://vuex.vuejs.org/en/mutations.html
import router from '@/router';
import { subscriptionRedirectPath } from '@/router/session-navigation';

export default {
  //
  displaySidebar(state, disp) {
    state.displaySidebar = disp;
  },
  displayMainToolbar(state, disp) {
    state.displayMainToolbar = disp;
  },
  displayWebsiteToolbar(state, disp) {
    state.displayWebsiteToolbar = disp;
  },
  // themeSetTheme(state, theme) {
  //   localStorage.setItem('theme', theme);
  //   state.theme = theme
  // },
  error(state, error) {
    localStorage.setItem('error', error);
    state.error = error;
  },
  SET_ERROR(state, error) {
    if (!error) {
      state.error = null;
      return;
    }

    const response = error.response;
    if (response && response.status === 426) {
      state.error = null;
      const destination = subscriptionRedirectPath(state.auth && state.auth.user);
      if (router.currentRoute.path !== destination) {
        router.push({ path: destination }).catch(() => {});
      }
    } else {
      state.error = error;
    }
  },
  SET_SUCCESS(state, success) {
    state.success = success;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_DELETE(state, item) {
    state.delete = item;
  },
};
